/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPotluckPicnicTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPotluckPicnic,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Enjoy a Potluck Picnic!",
    "Potluck Picnic Awaits!",
    "Food and Fun in the Sun!",
  ],
  title: "Potluck Picnic",
  description: "Organize a fun potluck picnic.",
  longDescription:
    "Gather your friends for an exciting potluck picnic! Choose a date, decide on dishes to bring, and plan activities!",
  emoji: "🥗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Potluck Picnic",
          emoji: "🥗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the potluck picnic?",
          emoji: "📅",
          completeAction: {
            question: "Decide on dishes to bring?",
            description: "What dishes should we focus on during the picnic?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What dishes should we consider?",
                emoji: "🍽",
                completeAction: {
                  question: "Decide on activities?",
                  description: "What activities should we plan for the picnic?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we include?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Picnic Together!",
    outroDescription: "Your potluck picnic plans are set! Enjoy the feast!",
  },
};
